import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  QueryAndOutputs,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SingleOutputWorkflowComponent } from './common/singleoutputcomponent'

class GeometryToGeography extends SingleOutputWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.geometrytogeography',
        group: 'Data Preparation',
        title: 'Geometry to Geography',
        description:
          'This component converts a column from geometry to geography data type.'
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geometry column',
          parent: 'source',
          dataType: [ColumnDataType.Geometry]
        }
      ]
    )
  }

  async getCode({
    workflow,
    params,
    connection,
    componentName,
    codeType
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs | null> {
    const outputTablename = connection.getOutputTableName(
      workflow.id,
      componentName,
      params,
      'result',
      codeType
    )
    const preparedParams = this._prepareParameters(params)
    let query = ''
    switch (connection.type) {
      case Provider.Snowflake: {
        const select = `SELECT * EXCLUDE(${preparedParams.geo}),
              TO_GEOGRAPHY(
                ST_ASGEOJSON(${preparedParams.geo})
              ) AS ${preparedParams.geo}
              FROM ${connection.quoteName(preparedParams.source as string)}`
        query = connection.getCreateTempTableQuery(
          outputTablename,
          select,
          codeType,
          null
        )
        break
      }
      default:
        return null
    }
    return {
      query,
      outputs: { result: outputTablename }
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: params.geo as string,
      type: ColumnDataType.Geography
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.Snowflake]
  }
}

export { GeometryToGeography }
